import PropTypes from "prop-types";
import { motion, useReducedMotion } from "framer-motion";
import "./SkillMeter.scss";

const SkillMeter = ({ name, level, icon: Icon }) => {
  const reduce = useReducedMotion();
  return (
    <div className="skill-meter">
      <div className="skill-meter__head">
        <span className="skill-meter__name">
          {Icon && <Icon aria-hidden="true" className="skill-meter__icon" />}
          {name}
        </span>
        <span className="skill-meter__value">{level}%</span>
      </div>
      <div
        className="skill-meter__track"
        role="meter"
        aria-label={`${name} proficiency`}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={level}
      >
        <motion.span
          className="skill-meter__fill"
          initial={reduce ? false : { scaleX: 0 }}
          whileInView={{ scaleX: level / 100 }}
          style={reduce ? { transform: `scaleX(${level / 100})` } : undefined}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
    </div>
  );
};

SkillMeter.propTypes = {
  name: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  icon: PropTypes.elementType,
};

export default SkillMeter;
